export default {
  imageContainer: (productAvailable: boolean, miniCart: boolean) => ({
    position: 'relative',
    flexShrink: 0,
    height: ['100px', '100px', '100%'],
    width: miniCart ? '100px' : ['91px', '91px', '100px'],
    opacity: productAvailable ? 1 : 0.2,
    display: 'flex',
    alignItems: 'center'
  })
};